import React from "react";

import {Box, Stack, Text, TextBlock, usePatronTheme, View} from "@unibuddy/patron";
import {boldFontStyles} from "ubcommunity-shared/src/Styles/fontStyles";

export const TextIndicator = ({currentStep, totalSteps, stepTitle}) => (
    <Stack space="medium">
        <Box>
            <TextBlock size="medium">{`Step ${currentStep} of ${totalSteps}`}</TextBlock>
        </Box>
        <Box>
            <Text size="large" weight="bold" style={{...boldFontStyles}}>
                {stepTitle}
            </Text>
        </Box>
    </Stack>
);

export const BarIndicator = ({
    currentStep,
    totalSteps,
}: {
    currentStep: number;
    totalSteps: number;
}) => {
    const theme = usePatronTheme();

    const isCompleted = (step): boolean => {
        if (step <= currentStep) {
            return true;
        }
        return false;
    };

    return (
        <View flexDirection="row" zIndex={10}>
            {Array(totalSteps)
                .fill(1)
                .map((_, i) => (
                    <Box
                        backgroundColor={isCompleted(i + 1) ? theme?.colors.primaryColor : "grey"}
                        flex={1}
                        height={4}
                        key={i}
                    />
                ))}
        </View>
    );
};

export const StepIndicator = {
    TextIndicator,
    BarIndicator,
};
